import initVimeoControllerByAttributes from '../common-util/vimeo/init-vimeo-controller-by-attributes'
import { BehaviorSubject } from 'rxjs'

const vimeoContainerInitiatedClass = 'video-player--initiated'
const vimeoContainerClass = 'video-player__video'
const initButtonClass = 'video-player__init-button'

export default class VideoCoverController {
  constructor (element) {
    this._element = element
    this._bindUIActions()
  }

  _initVimeo () {
    const vimeoContainer = this._getVimeoContainer()
    this._vimeoController = initVimeoControllerByAttributes(vimeoContainer)
    vimeoContainer.vimeoController = this._vimeoController

    this._vimeoController.player.then(player => {
      player.setVolume(0)
      this._element.classList.add(vimeoContainerInitiatedClass)
    })
  }

  _play () {
    return this._vimeoController.player.then(player => {
      player.play()
    })
  }

  _getInitButton () {
    return this._element.querySelector('.' + initButtonClass)
  }

  _getVimeoContainer () {
    return this._element.querySelector('.' + vimeoContainerClass)
  }

  _bindUIActions () {
    this._getInitButton().addEventListener('click', () => {
      this._initVimeo()
      this._play()
    })

    // combineLatest(this.pausedSubject, this.mutedSubject).subscribe((paused, muted) => {
    //   if (paused) {
    //     this._getPlayButton().style.display = 'block'
    //     this._getUnmuteButton().style.display = 'none'
    //   } else if (muted) {
    //     this._getPlayButton().style.display = 'none'
    //     this._getUnmuteButton().style.display = 'block'
    //   } else {
    //     this._getPlayButton().style.display = 'none'
    //     this._getUnmuteButton().style.display = 'none'
    //   }
    // })
  }
}
